import { isString, parseInt, isFinite } from 'lodash'
import moment from 'moment'
import { FIELD_RULES } from '../constants'

/* eslint no-useless-escape: 0 */

const {
  ALPHABETICAL,
  ALPHANUMERIC,
  REQUIRED,
  EMAIL,
  EQUAL,
  INCLUDES_LETTER,
  INCLUDES_NUMBER,
  INCLUDES_SYMBOL,
  LATIN,
  MAX,
  MAX_AGE,
  MAX_LENGTH,
  MIN,
  MIN_AGE,
  MIN_LENGTH,
  NUMERIC
} = FIELD_RULES

const validator = {
  [ALPHABETICAL]: (field) => {
    const { value } = field

    if (!isString(value) || value === '') {
      return true
    }

    return /^[\p{L}\-_ ]+$/u.test(value)
  },
  [ALPHANUMERIC]: (field) => {
    const { value } = field

    if (!isString(value) || value === '') {
      return true
    }

    return /^[\p{L}0-9\-_ ]+$/u.test(value)
  },
  [EMAIL]: (field) => {
    const { value } = field

    if (!isString(value) || value === '') {
      return true
    }

    return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
      value
    )
  },
  [EQUAL]: (field, fields, ref) => {
    const { value } = field
    const refField = fields[ref]

    if (!refField) {
      return false
    }

    const refValue = refField.value

    return value === refValue
  },
  [INCLUDES_LETTER]: (field) => {
    const { value } = field

    if (!isString(value) || value === '') {
      return true
    }

    return /[\p{L}]/u.test(value)
  },
  [INCLUDES_NUMBER]: (field) => {
    const { value } = field

    if (!isString(value) || value === '') {
      return true
    }

    return /[0-9]/u.test(value)
  },
  [INCLUDES_SYMBOL]: (field) => {
    const { value } = field

    if (!isString(value) || value === '') {
      return true
    }

    return /[!@#$%^&*()_+\-=\[\]{};`':"\\|,.<>\/?]/u.test(value)
  },
  [LATIN]: (field) => {
    const { value } = field

    if (!isString(value) || value === '') {
      return true
    }

    return /^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};`':"\\|,.<>\/?]*$/.test(value)
  },
  [MAX]: (field, fields, ruleOption) => {
    const { value } = field
    const max = parseInt(ruleOption)

    if (!isFinite(max) || !isFinite(value)) {
      return true
    }

    return value <= max
  },
  [MAX_AGE]: (field, fields, ruleOption) => {
    const { value } = field
    const max = parseInt(ruleOption)
    const date = moment(value)

    if (!isFinite(max) || !date.isValid()) {
      return true
    }

    return moment().diff(date, 'years') <= max
  },
  [MAX_LENGTH]: (field, fields, ruleOption) => {
    const { value } = field
    const max = parseInt(ruleOption)

    if (!isFinite(max) || !isString(value) || value === '') {
      return true
    }

    return value.length <= max
  },
  [MIN]: (field, fields, ruleOption) => {
    const { value } = field
    const min = parseInt(ruleOption)

    if (!isFinite(min) || !isFinite(value)) {
      return true
    }

    return value >= min
  },
  [MIN_AGE]: (field, fields, ruleOption) => {
    const { value } = field
    const min = parseInt(ruleOption)
    const date = moment(value)

    if (!isFinite(min) || !date.isValid()) {
      return true
    }

    return moment().diff(date, 'years') >= min
  },
  [MIN_LENGTH]: (field, fields, ruleOption) => {
    const { value } = field
    const min = parseInt(ruleOption)

    if (!isFinite(min) || !isString(value) || value === '') {
      return true
    }

    return value.length >= min
  },
  [NUMERIC]: (field) => {
    const { value } = field

    if (isFinite(value)) {
      return true
    } else if (isString(value)) {
      return /^[0-9]+$/.test(value)
    }

    return true
  },
  [REQUIRED]: (field) => {
    const { value } = field

    return value || isFinite(value)
  }
}

export default validator
